import { z } from 'zod';

export const FindConditionsQuerySchema = z.object({
  reactionSmiles: z.string(),
  reactionClass: z.string(),
  reagents: z.record(z.string(), z.string()).optional().default({}),
});
export type FindConditionsQuery = z.infer<typeof FindConditionsQuerySchema>;
